import { Navigate } from 'react-router'
import { useEffect } from 'react'
import { useLogout } from '@/feature/auth/api'

export const Logout = () => {
  const logout = useLogout()
  useEffect(() => {
    logout()
  }, [logout])
  return <Navigate to='/auth/login' />
}
